import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncEventHubHome({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/EventHubHome"));
  console.log("Loading", AsyncEventHubHome.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncEventHubHome;
